import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import clsx from "clsx";

const TelevisionIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={clsx("qi-icon qi-icon-television", className)}
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M15.7056 17.6554H5.06873C3.68801 17.6554 2.56873 16.5362 2.56873 15.1554V5.69336C2.56873 4.31265 3.68801 3.19336 5.06873 3.19336H18.9313C20.312 3.19336 21.4313 4.31265 21.4313 5.69336V15.1554C21.4313 16.5362 20.312 17.6554 18.9313 17.6554H18.5201"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M7.8075 11.7949L9.87169 9.21402C10.2435 8.74909 10.9368 8.71004 11.3585 9.13026L11.9878 9.75731C12.3999 10.168 13.0742 10.1415 13.4528 9.69978L16.1543 6.5484"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9247 20.8065V17.6553H10.0754V20.8065"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M7.39282 20.7979H16.6073"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M10.4515 14.472H12.6195H13.5487"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export default memo(TelevisionIcon);
